import * as React from 'react';

import { LayoutBlock } from '../LayoutBlock';
import { Section } from '../Section';
import { INewbuildingSeller } from '../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { BuildersContainer } from '../../containers/BuilderBlockContainer';
import { AgentsContainer } from '../../containers/Agents';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export interface IBuildersInfoProps {
  builders?: INewbuildingBuilder[] | null;
  sellers?: INewbuildingSeller[] | null;
  isLeadFactory?: boolean;
  agentsShowHandler: () => void;
  buildersShowHandler: () => void;
}

export const BuildersInfo: React.FC<IBuildersInfoProps> = props => {
  const { builders, sellers, isLeadFactory, agentsShowHandler, buildersShowHandler } = props;

  const isBuildersHere = builders && builders.length > 0;
  const isSellersHere = sellers && sellers.length > 0;

  if (!isBuildersHere && !isSellersHere) {
    return null;
  }

  return (
    <LayoutBlock data-testid="BuildersInfo">
      <Section id="developer" data-data-nav-tab="developer/Про застройщика" data-mark="BuildersInfo">
        <ActionAfterViewObserver triggerOnce callback={buildersShowHandler}>
          <BuildersContainer />
        </ActionAfterViewObserver>
        {!isLeadFactory && (
          <ActionAfterViewObserver triggerOnce callback={agentsShowHandler}>
            <AgentsContainer />
          </ActionAfterViewObserver>
        )}
      </Section>
    </LayoutBlock>
  );
};
